module.exports = __webpack_public_path__ + "static/responsive-mock-6172f690266c9aaaa060825bffe8e8b3.png";